import { CalendarDays, Settings } from "lucide-react";
import { Link, NavLink } from "react-router-dom";

export function AppHeader() {
  return (
    <header className="app-header">
      <Link className="brand" to="/" aria-label="返回支出日历">
        <span className="brand-mark"><CalendarDays size={21} /></span>
        <span>轻账</span>
      </Link>
      <nav aria-label="主要导航">
        <NavLink className={({ isActive }) => `nav-link${isActive ? " active" : ""}`} to="/" end>
          日历
        </NavLink>
        <NavLink className={({ isActive }) => `nav-link icon-link${isActive ? " active" : ""}`} to="/settings">
          <Settings size={17} />
          <span>设置</span>
        </NavLink>
      </nav>
    </header>
  );
}
